import type { ComponentProps, FC } from 'react';

import LoadingButton from '@/components/functional/LoadingButton/LoadingButton.tsx';
import { cn } from '@/utils/classNames.ts';

type DnaPrimaryButtonProps = ComponentProps<typeof LoadingButton>;

const DnaPrimaryButton: FC<DnaPrimaryButtonProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <LoadingButton
      {...props}
      color="primary"
      className={cn(
        'journi-primary-button !min-h-0 w-full max-w-[312px] !rounded-[9px] !border-0 !bg-[linear-gradient(180deg,var(--gold-lt)_0%,var(--gold)_58%,var(--gold-deep)_100%)] px-[34px] py-4 font-sans !text-base font-medium normal-case !text-[var(--ink)] shadow-[0_8px_24px_rgba(180,146,58,0.2)] transition-[transform,box-shadow,filter] duration-500 ease-[cubic-bezier(.22,1,.36,1)] hover:!-translate-y-0.5 hover:brightness-105 hover:shadow-[0_12px_28px_rgba(180,146,58,0.28)] active:!translate-y-0 active:brightness-95',
        className
      )}
    >
      {children}
    </LoadingButton>
  );
};

export default DnaPrimaryButton;
